import React, { useState } from "react";
import productImage from "../assets/images/product.png";
import productImage2 from "../assets/images/productp.png";
import arrow from "../assets/images/down.png";

const Product = () => {
  const [colorPicked, setColorPicked] = useState(true);

  const [openList, setOpenList] = useState(false);

  return (
    <div className="productContainer">
      {colorPicked ? (
        <img src={productImage} alt="product image" className="fridgeImage" loading="lazy"/>
      ) : (
        <img src={productImage2} alt="product image" className="fridgeImage" loading="lazy"/>
      )}

      <div className="productContent">
        <h1 data-aos="fade-up" data-aos-duration="2000">
          Twin Peaks
        </h1>

        <p>یخچال و فریزر دوقلو</p>

        <div className="colorPicker">
          <div
            className={`colorPicked ${colorPicked ? "" : "picked"}`}
            onClick={() => setColorPicked(true)}
          >
            <div class="circle">
              <div class="inner-circle" style={{ background: "#D9D9D9" }}></div>
            </div>
            {colorPicked ? "اینوکس" : ""}
            {/* اینوکس */}
          </div>
          <div
            className={`colorPicked ${colorPicked ? "picked" : ""}`}
            onClick={() => setColorPicked(false)}
          >
            <div class="circle">
              <div class="inner-circle"></div>
            </div>
            {colorPicked ? "" : "سفید"}
          </div>
        </div>

        <div className="productAttributes">
          <p className="attributeTitles">مشخصات کلی</p>

          <div className="productAttribute">
            <span>نام مدل</span>

            <span>RTRA-RTFA901 i</span>
          </div>
          <div className="productAttribute">
            <span>نوع محصول</span>

            <span>یخچال و فریزر دوقلو</span>
          </div>
          <div className="productAttribute">
            <span>سری محصول</span>

            <span>Twin Peaks</span>
          </div>
          <div className="productAttribute">
            <span>ابعاد یخچال (ارتفاع*عمق*عرض)</span>

            <span>1870*730*590</span>
          </div>
          <div className="productAttribute">
            <span>ابعاد فریزر (ارتفاع*عمق*عرض)</span>

            <span>1870*730*590</span>
          </div>
          <div className="productAttribute">
            <span>ظرفیت کل محصول (لیتر)</span>

            <span>900 لیتر</span>
          </div>
          <div className="productAttribute">
            <span>وزن خالص یخچال</span>

            <span>71 کیلوگرم</span>
          </div>
          <div className="productAttribute">
            <span>وزن خالص فریزر</span>

            <span>79 کیلوگرم</span>
          </div>

          {openList && (
            <>
              <p className="attributeTitles">مشخصات ویژه</p>

              <div className="productAttribute">
                <span>نوع کمپرسور</span>

                <span>اینورتر دیجیتال</span>
              </div>
              <div className="productAttribute">
                <span>اتصال به اینترنت</span>

                <span>اتصال جهت عیب‌یابی</span>
              </div>
              <div className="productAttribute">
                <span>حالت تعطیلات</span>

                <span>دارد</span>
              </div>
              <div className="productAttribute">
                <span>دارای تکنولوژی مدیریت مصرف انرژی (ECO)</span>

                <span>دارد</span>
              </div>
              <div className="productAttribute">
                <span>حسگرهای هوشمند تشخیص دمای داخلی</span>

                <span>دارد</span>
              </div>
              <div className="productAttribute">
                <span>گردش هوای سه بعدی</span>

                <span>دارد</span>
              </div>
              <div className="productAttribute">
                <span>بدون برفک</span>

                <span>دارد</span>
              </div>

              <div className="productAttribute">
                <span>هشدار باز بودن درب</span>

                <span>دارد</span>
              </div>
              <div className="productAttribute">
                <span>مصرف انرژی</span>

                <span>A+</span>
              </div>
              <div className="productAttribute">
                <span>سیستم خنک کننده همه جانبه</span>

                <span>دارد</span>
                </div>

                <div className="productAttribute">
                  <span>گاز R600a سازگار با محیط زیست</span>

                  <span>دارد</span>
                </div>

                <p className="attributeTitles">مشخصات ظاهری</p>

                <div className="productAttribute">
                  <span>رنگ بدنه</span>

                  <span>اینوکس - سفید</span>
                </div>
                <div className="productAttribute">
                  <span>قفل صفحه نمایش</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>نوار درزگیر آنتی باکتریال با قابلیت تعویض</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>بدنه مقاوم در برابر اثر انگشت</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>نوع صفحه نمایش</span>

                  <span>LED تمام لمسی</span>
                </div>
                <div className="productAttribute">
                  <span>یخساز و آبسرد کن</span>

                  <span>دارد</span>
                </div>

                <p className="attributeTitles">مشخصات فریزر</p>

                <div className="productAttribute">
                  <span>یخساز</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>نوع یخساز</span>

                  <span>اتوماتیک با قابلیت اتصال به آب شهری</span>
                </div>
                <div className="productAttribute">
                  <span>گنجایش فریزر</span>

                  <span>420 لیتر</span>
                </div>
                <div className="productAttribute">
                  <span>روشنایی کم مصرف LED</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>انجماد سریع Power Freeze</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد طبقات</span>

                  <span>3</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد قفسه درب</span>

                  <span>2</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد کشو</span>

                  <span>4</span>
                </div>

                <p className="attributeTitles">مشخصات یخچال</p>
                <div className="productAttribute">
                  <span>آب سرد‌کن</span>

                  <span>آب سردکن دستی با پدال قفل شونده</span>
                </div>
                <div className="productAttribute">
                  <span>فیلتر تصفیه آب</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>گنجایش یخچال</span>

                  <span>480 لیتر</span>
                </div>
                <div className="productAttribute">
                  <span>روشنایی کم مصرف LED</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>سرمایش سریع Power Cool</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>فیلتر تصفیه هوای داخلی</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد طبقات</span>

                  <span>5</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد قفسه درب</span>

                  <span>7</span>
                </div>
                <div className="productAttribute">
                  <span>تعداد کشو</span>

                  <span>2</span>
                </div>
                <div className="productAttribute">
                  <span>جنس طبقات</span>

                  <span>شیشه‌ای سکوریت</span>
                </div>
                <div className="productAttribute">
                  <span>جا لبنیاتی</span>

                  <span>دارد</span>
                </div>
                <div className="productAttribute">
                  <span>محفظه نگهداری میوه و سبزیجات</span>

                  <span>دارد</span>
                </div>

        
            </>
          )}

{openList ?      <a onClick={() => setOpenList(false)}>
            بستن لیست <img src={arrow} alt="arrow icon" className="closeIcon" loading="lazy"/>
          </a>:      <a onClick={() => setOpenList(true)}>
            مشاهده همه <img src={arrow} alt="arrow icon" loading="lazy"/>
          </a> }
        </div>
      </div>
    </div>
  );
};

export default Product;
